import { render, staticRenderFns } from "./HoldingDetail.vue?vue&type=template&id=3025adea&scoped=true&"
import script from "./HoldingDetail.vue?vue&type=script&lang=js&"
export * from "./HoldingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3025adea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3025adea')) {
      api.createRecord('3025adea', component.options)
    } else {
      api.reload('3025adea', component.options)
    }
    module.hot.accept("./HoldingDetail.vue?vue&type=template&id=3025adea&scoped=true&", function () {
      api.rerender('3025adea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/operations/vistas/transactionality/HoldingDetail.vue"
export default component.exports